import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer'
import sendbirdSelectors from '@sendbird/uikit-react/sendbirdSelectors'
import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext'
import { useState } from 'react'
import { AiOutlineSend } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import { setUploaded } from '../../../redux/slices/chatMessages'
import { SaveChannelMessage, UpdateChannelLatestMessage } from '../../../redux/actions/chat'
import { saveChatFileInAWS } from '../../../utils/services/chat.service'

export const DisplayProfile = ({
  imageUrl,
  fileName,
  file,
  channel,
  onClose,
  selectedChat
}) => {
  const store = useSendbirdStateContext()
  const sendFileMessage = sendbirdSelectors?.getSendFileMessage(store)
  const [isSending, setIsSending] = useState(false)
  const dispatch = useDispatch()
  const { userInfo } = useSelector(
    (state) => state.auth
  );
  
  const saveChatInAWS=async ()=>{
   const fileMessageParams = new FormData();
   fileMessageParams.append("file", file); 
   fileMessageParams.append("provider_id", 10);
   saveChatFileInAWS(fileMessageParams).then((res)=>{
    onClose()
    setIsSending(true)
    if(res.data.result=='success'){
      sendFile(res.data);
    }
   });
  }

  const sendFile = (res) => {
    const fileMessageParams={fileUrl :res?.url,fileName:res?.file_name,mimeType:res?.file_type};
    sendFileMessage(channel, fileMessageParams)
      .onSucceeded((message) => {
        setIsSending(false)
        dispatch(setUploaded());
        if (selectedChat) {
          var receiverType, receiverUserID
          if (channel.name == 'Teams') {
            receiverType = 'internal_doctor'
          } else if (channel.name == 'Admin') {
            receiverType = 'admin'
          } else if (channel.name == 'DPCDoctor') {
            receiverType = 'patient'
          }
          receiverUserID = selectedChat.id
        } else if (!selectedChat && channel.name == 'Admin') {
          receiverType = 'admin'
          receiverUserID = 1
        }
        if (message && receiverType && receiverUserID) {
          let data = {
            sendbird_user_id: message.sender.userId,
            sendbird_channel_url: message.channelUrl,
            user_type:
              userInfo &&
              userInfo.doctor_login &&
              userInfo.doctor_login.user_type &&
              userInfo.doctor_login.user_type.length > 0
                ? userInfo.doctor_login.user_type
                : 'doctor',
            message_id: message.messageId,
            user_id: userInfo?.id,
            receiver_type: receiverType,
            receiver_user_id: receiverUserID,
          }
          dispatch(SaveChannelMessage({ data: data })).then((res) => {
              data = {...data,message:fileMessageParams?.fileUrl,message_type:"file"}
              dispatch(UpdateChannelLatestMessage({ data: data })) 
          });
        }
        onClose()
      })
      .onFailed((err) => {
        setIsSending(false)
        console.log({ err })
      })
  }

  return (
    <div className='p-10'>
      <DocViewer
        documents={[
          {
            uri: imageUrl,
            fileName: fileName,
          },
        ]}
        pluginRenderers={DocViewerRenderers}
        className='w-[800px] h-[100%] text-2xl cursor-pointer '
      />
      <div className='flex justify-end mt-5'>
        <button
          type='button'
          className='p-5  h-[35px] text-white  bg-everglade-800 hover:bg-everglade-400 rounded-md flex items-center justify-center'
          onClick={saveChatInAWS}
          disabled={isSending}
        >
          <AiOutlineSend size={25} />
        </button>
      </div>
    </div>
  )
}
